module.exports = __webpack_public_path__ + "static/media/remoteretro.3889346b.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/blocks/remoteretro.png
// module id = 87
// module chunks = 0